import {
	Component,
	Inject,
	Input,
	OnInit,
	OnChanges,
	AfterContentInit,
} from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { CentrosProcedureViewModel } from "src/app/_core/models/master/centro.model";
import { SiteViewModel } from "src/app/_core/models/master/site.model";

@Component({
	selector: "app-map-details-dialog",
	templateUrl: "./map-details-dialog.component.html",
	styleUrls: ["./map-details-dialog.component.scss"],
})
export class MapDetailsDialogComponent implements OnInit, OnChanges {
	constructor(private readonly _router: Router) {}

	@Input() site: CentrosProcedureViewModel;

	// Events
	ngOnInit(): void {}

	ngAfterContentInit(): void {}

	ngOnChanges() {}

	// Public methods
	goToSite() {
		this._router.navigate([`/centro/${  this.site.id}`]);
	}

	/* goToService() {
    this._router.navigate(["/service/" + this.site.codigo]);
  } */

	getUppercaseOnly(value: string): string {
		return (value.match(/[A-Z]/g) || []).join("");
	}
}
